export default __webpack_public_path__ + "static/media/info-tooltip-icon.9f3cc253.svg";